import {Container} from 'reactstrap';
import _ from "./../Trans";
import Config from '../Config';

export default function Footer() {
    const rulesText = _('Rules');
    const tcText = _('Terms and conditions');
    let signature = Config.appCustomer === 'asobal' ? _('Asobal Fantasy') : _('Supermanager');
    return (
        <footer className="footer mt-2">
          <Container>
              {Config.appCustomer === 'asobal' &&
                  <img
                      src={`${process.env.REACT_APP_STATIC_URL}/logo_liga_nexus_asobal.png`}
                      alt="Liga Nexus Energía Asobal"
                      className="footer-sponsor-logo"
                  />
              }
              <span className="mr-2 footer-project">
                  2023-2025 - {signature}
              </span>
              <span className="text-muted mr-2">
                  <a href="/rules/">{rulesText}</a>
              </span>
              <br/>
              <span className="text-muted mr-2">
                  <a href="/tc/">{tcText}</a>
              </span>
          </Container>
        </footer>
    )
}
